import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import Button from '../../components/Buttons/Button';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import ButtonBar from '../../components/Fields/ButtonBar';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import Form from '../../components/Form/Form';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import SearchCriteria from '../../models/common/SearchCriteria';
import ItemRevisionModel from '../../models/ItemRevisionModel';
import ItemTypeModel from '../../models/ItemTypeModel';
import DataService from "../../services/data.service";
import Unauthorized from '../Authentication/Unauthorized';
import OfType_popup_CreateItem from './Popups/OfType_popup_CreateItem';

interface itemsOfTypeSearchCriteria extends SearchCriteria {
    itemTypeId?: number
}

const ItemsOfType: React.FC = () => {
    const itemTypeId = Number(useParams().itemTypeId)
    const [title, setTitle] = useState<string>('')
    const [data, setData] = useState<ItemRevisionModel[]>();
    const [showCreateItemPopup, setShowCreateItemPopup] = useState<boolean>(false);
    const { handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    const [formData, setFormData] = useState<itemsOfTypeSearchCriteria>({
        itemTypeId: itemTypeId,
        quickSearch: ''
    })

    useEffect(() => {
        getItemType();

        const filterItem = localStorage.getItem(`itemOfType=${itemTypeId}`)
        if (filterItem !== null) {
            let filter: itemsOfTypeSearchCriteria = JSON.parse(filterItem)
            setFormData(filter)
            getTableData(filter)
        }
        else
            setDefaultCriteria()

    }, [itemTypeId]);

    function search() {
        if (formData.quickSearch.length >= 3)
            getTableData(formData)
    }

    function setDefaultCriteria() {
        setFormData({ itemTypeId: itemTypeId, quickSearch: '' })
        getTableData({ itemTypeId: itemTypeId, quickSearch: '' })
    }

    function getTableData(criteria) {
        localStorage.setItem('itemOfType=' + itemTypeId, JSON.stringify(criteria));
        DataService.post<ItemRevisionModel[]>('api/v1/ItemRevisions/OfType/', criteria)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function getItemType() {
        DataService.get<ItemTypeModel>('api/v1/ItemTypes/' + itemTypeId)
            .then(response => {
                setTitle(response.name);
            })
            .catch(e => { handleException(e); });
    }

    function getCellColor(itemRevision: ItemRevisionModel, colInfo: IColInfo): string | undefined {
        if (itemRevision.itemStatus)
            return itemRevision.itemStatus.color;
    }

    const formConfig: FormConfig = {
        fields: [{ name: 'quickSearch', label: 'Search' }],
        handleFieldChanged: search,
        handleSubmit: () => getTableData(formData),
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData);

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { getCellBackgroundColor: getCellColor, sort: false, width: 5 },
        { dataProp: 'thumbnailUrl', dataType: 'bigimage' },
        { title: 'Item Nr', dataProp: 'item.itemNr', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Name', dataProp: 'item.name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Version', dataProp: 'revisionNumber', dataType: 'number', width: 85, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Status', dataProp: 'itemStatus.name', width: 200, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Design phase', dataProp: 'designPhase', width: 200, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Projects', dataProp: 'projects', width: 200, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Created on', dataProp: 'createdOn', dataType: 'datetime', width: 160 },
        { title: 'Created by', dataProp: 'createdByUser', dataType: 'user' },
    ];

    if (!isAuthorizedForItemType(ApplicationFunctions.ViewItemsOfType, itemTypeId))
        return (<Unauthorized />);

    if (!itemTypeId)
        return null;

    return (
        <div className='main-content'>
            <Form>
                <Form.Header title={title} >
                    <ActionMenu title="Actions">
                        <ActionMenuItem width={300} icon="fa fa-plus" iconVariant="success" title={"Create new " + title} onClick={() => { setShowCreateItemPopup(true); }} />
                    </ActionMenu>
                </Form.Header>
                <Form.Content>
                    <TextboxField {...getFieldProps('quickSearch')} />
                </Form.Content>
                <Form.Footer>
                    <ButtonBar offset={2}>
                        <Button text='Search' {...getSubmitButtonProps()} />
                        <Button text='Clear' type='button' onClick={setDefaultCriteria} />
                    </ButtonBar>
                </Form.Footer>
            </Form>
            <div className="card" style={{ margin: '0 12px', padding: 12 }}>
                <DataTable
                    name='dtItemsOfType'
                    colInfos={colInfos}
                    tableData={data}
                    navigateTitle='Itemrevision'
                    navigateUrl='/plm/Items/ItemRevision/'
                />
            </div>

            { showCreateItemPopup && <OfType_popup_CreateItem itemTypeId={itemTypeId} itemTypeName={title} show={showCreateItemPopup} onHide={() => setShowCreateItemPopup(false)} />}
        </div>
    );
}
export default ItemsOfType;